(function () {
  function init() {
    var root = document.querySelector('[id^="kk-hero-immersive-"]');
    if (!root || root.dataset.kkBound === '1') return;
    root.dataset.kkBound = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
    var dots   = Array.prototype.slice.call(root.querySelectorAll('[data-hero-go]'));
    var ppBtn  = root.querySelector('[data-hero-playpause]');

    if (slides.length < 2) return;

    var i = 0;
    var timer = null;
    var autoplayAllowed = root.getAttribute('data-autoplay') === 'true';
    var DUR = parseInt(root.getAttribute('data-interval-ms'), 10) || 7000;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var manuallyPaused = false;

    try {
      var sp = new URLSearchParams(location.search).get('slide');
      if (sp !== null) {
        var n = parseInt(sp, 10);
        if (!isNaN(n)) i = ((n % slides.length) + slides.length) % slides.length;
      }
    } catch (e) {}

    function canAutoplay() {
      return autoplayAllowed && !reduce && !manuallyPaused;
    }

    function paint() {
      slides.forEach(function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
      });
      dots.forEach(function (d, n) {
        var on = n === i;
        d.classList.toggle('is-active', on);
        if (on) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
    function go(n) { i = (n + slides.length) % slides.length; paint(); restart(); }
    function next() { go(i + 1); }
    function prev() { go(i - 1); }
    function restart() {
      if (timer) { clearInterval(timer); timer = null; }
      if (!canAutoplay()) return;
      timer = setInterval(next, DUR);
    }

    function setPaused(paused) {
      manuallyPaused = paused;
      if (ppBtn) {
        ppBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        /* Labels are merchant settings, handed over on the button itself. */
        var lbl = paused ? ppBtn.getAttribute('data-resume-label') : ppBtn.getAttribute('data-pause-label');
        if (lbl) ppBtn.setAttribute('aria-label', lbl);
      }
      if (paused) {
        if (timer) { clearInterval(timer); timer = null; }
      } else {
        restart();
      }
    }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { go(n); });
    });
    var nextBtn = root.querySelector('[data-hero-next]');
    var prevBtn = root.querySelector('[data-hero-prev]');
    if (nextBtn) nextBtn.addEventListener('click', next);
    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (ppBtn) {
      ppBtn.addEventListener('click', function () { setPaused(!manuallyPaused); });
    }

    var pauseZone = root.querySelector('[data-hero-pause]') || root;
    pauseZone.addEventListener('mouseenter', function () {
      if (manuallyPaused) return;
      if (timer) { clearInterval(timer); timer = null; }
    });
    pauseZone.addEventListener('mouseleave', function () {
      if (manuallyPaused) return;
      restart();
    });

    document.addEventListener('keydown', function (e) {
      if (!root.isConnected) return;
      if (e.key === 'ArrowRight') next();
      else if (e.key === 'ArrowLeft') prev();
    });

    paint();
    restart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
